module.exports = __webpack_public_path__ + "static/pointmobile-7a18d1df9cea0c21e19b5b843b36b10b.png";